var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"badge",class:_vm.computedStyle,style:({
    ..._vm.customBackgroundColor,
    ..._vm.customTextColor
  }),attrs:{"data-testid":"badge"}},[_c('span',[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }